<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    :editIcon="editIcon"
    :readOnly="readOnly"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :isTextButton="isTextButton"
    :textButton="textButton"
    editSaveButtonLabel="Faturar Compra"
    buttonColor="success"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        id="printableELement"
        :partialReadOnly="true"
        @installment-update="loadServerEntry(entry.id)"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    <!-- <template slot="action1">
      <BasePrint
        printableElementId="printableELement"
        printButtonLabel="Imprimir Prévia da Venda"
        printTitle="Prévia das Informações da Venda"
        @start-printing="pageLoading = true"
        @stop-printing="pageLoading = false"
      />
    </template> -->
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    modelNameSingular: String,
    editIcon: {
      type: String,
      default: "mdi-cart-arrow-down"
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isTextButton: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String,
    }
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit,
    BasePrint: BasePrint
  },
  created() {
    // console.log("edit purchase created");
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_PURCHASE_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.purchase;
          this.extraData = response.data;
          // console.log("purchase edit", this.editableEntry);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(purchase) {
      // console.log("PURCHASE", purchase, purchase.validations, this.deepFilterEntryWithAllowedFieldsForMutation(purchase, purchase.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: BILLING_PURCHASE_MUTATION,
          variables: {
            id: purchase.id,
            input: {
              billDate: purchase.billDate,
              number: purchase.number,
              series: purchase.series,
              observation: purchase.observation
            } //this.deepFilterEntryWithAllowedFieldsForMutation(purchase, purchase.validations)
          }
        })
        .then(response => {
          var errors = response.data.billPurchase.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry)
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
      this.$emit("entry-canceled");
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_PURCHASE_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      purchase(id: $id) {
        id
        code
        cfopId
        series
        number
        billDate
        estimatedDeliveryDate
        orderValidity
        supplierId
        customerId
        totalPrice
        validations
        observation
        totalCarriageValue
        totalDiscountValue
        totalInsuranceValue
        otherExpensesTotalValue
        dummyEntryMovementItemsAttributes {
          id
          price
          unitPrice
          quantity
          itemId
          item {
            id
            name
            description
            unit {
              name
            }
          }
          dummyEntryMovementItemLotsAttributes{
            id
            itemLotAttributes{
              id
              name
              code
              dueDate
              manufacturingDate
              lotNumber
            }
            quantity
            packagingQuantity
          }
          packagingId
          packaging {
            id
            name
            size
            text
          }
          storageId
          storage {
            id
            name
            location
          }
          validations
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsIntervalId
          installmentsInterval {
            id
            description
            intervalInDays
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            bankAccount {
              id
              name
            }
          }
        }
      }
      allSuppliers {
        id
        name
      }
      allCollaborators{
        id
        name
      }
      allPurchaseCfops{
        id
        text
      }
    }
    globalContext {
			allPaymentConditions {
        id
        description
        numberOfInstallments
      }
      allStates {
        id
        shortName
      }
    }
  }
`;

const BILLING_PURCHASE_MUTATION = gql `
  mutation($id: ID!, $input: BillPurchaseInputObject!) {
    billPurchase(id: $id, input: $input) {
      cashFlow {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
